import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { shopApi, shopError } from "../lib/shop";
import { useCustomerAuth } from "../context/CustomerAuthContext";
import { PageLoader } from "../components/LoadingRing";

/** Google returns here on rehealthme.com — we swap the code for the customer session. */
export default function GoogleCallback() {
    const nav = useNavigate();
    const { setCustomer } = useCustomerAuth();
    const [error, setError] = useState("");
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        const state = params.get("state");
        if (!code || !state) {
            setError(params.get("error_description") || params.get("error") || "Sign-in was cancelled");
            return;
        }
        (async () => {
            try {
                // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
                const { data } = await shopApi.post("/auth/google/callback", {
                    code, state, redirect_uri: `${window.location.origin}/auth/google`,
                });
                localStorage.setItem("rhm_customer_token", data.token);
                setCustomer(data.customer);
                toast.success(`Welcome${data.customer?.name ? `, ${data.customer.name.split(" ")[0]}` : ""}`);
                nav(data.next || "/account", { replace: true });
            } catch (e) {
                setError(shopError(e));
            }
        })();
    }, [nav, setCustomer]);

    return (
        <div className="pt-28 md:pt-32 pb-24 min-h-[60vh] flex items-center justify-center"
            data-testid="google-callback-page">
            <div className="text-center">
                {error ? (
                    <>
                        <h1 className="font-display text-3xl uppercase tracking-tight">Sign-in failed</h1>
                        <p className="text-sm text-zinc-400 mt-3 max-w-sm mx-auto" data-testid="google-callback-error">
                            {error}
                        </p>
                        <button onClick={() => nav("/account/login", { replace: true })}
                            data-testid="google-callback-retry"
                            className="mt-7 btn-pill btn-secondary">TRY AGAIN</button>
                    </>
                ) : (
                    <>
                        <PageLoader label="SIGNING YOU IN…" className="" />
                    </>
                )}
            </div>
        </div>
    );
}
